module.exports = __webpack_public_path__ + "img/40_38_035_730.c141eb97.jpg";